import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M49.68 70.27c-3.04 0-6.08-.07-9.11.02-1.85.06-2.48-.73-2.46-2.5.05-5.45.07-10.91-.01-16.36-.03-1.81.92-2.88 2.14-3.91 4.23-3.54 8.45-7.11 12.7-10.63 2.83-2.35 3.58-5.8 1.94-8.74-1.21-2.16-3.28-3.11-5.42-3.01-2.43.12-4.66 1.3-5.52 3.97-.19.59-.36 1.2-.48 1.81q-.77 3.75-4.69 3.75c-5.3 0-10.59-.03-15.89.02-1.69.02-2.52-.45-2.61-2.35-.75-14.57 9.84-27.27 23.22-29.73 18.06-3.33 32.08 7.53 35.17 23.44 1.93 9.91-.92 18.99-8.25 26.32-1.04 1.04-2.09 2.15-3.32 2.93-4.49 2.87-7.01 6.59-5.95 12.18.4 2.1-.67 2.92-2.81 2.81-2.88-.14-5.76-.03-8.65-.04ZM49.64 97.93c-6.51.74-11.74-5.85-11.57-11.33.2-6.5 4.99-11.41 11.55-11.41 6.61 0 11.37 4.87 11.57 11.4.17 5.54-5.08 12.08-11.56 11.34Z",
      class: "stroke-width: 0px"
    }, null, -1)
  ]))]))
}
export default { render: render }